webpackJsonp([54],{

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


function data() {
	return {
		filters: [{
			id: 1, value: 1, label: 'Día', days: 0
		}, {
			id: 2, value: 2, label: 'Semana', days: 7
		}, {
			id: 3, value: 3, label: 'Mes', days: 30
		}, {
			id: 4, value: 4, label: 'Año', days: 365
		}]
	};
}

function applyFilter(filter) {
	this.$emit('apply-filter', filter);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filters-by-time',
	data: data,
	props: {
		value: {
			type: Number,
			default: 1
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		applyFilter: applyFilter
	}
});

/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".filters-by-time[data-v-79facaf4]{color:#85939e;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:408px}.filters-by-time button.btn[data-v-79facaf4]{background-color:#fff!important;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);color:#85939e;font-size:14px!important;height:40px;margin-left:14px;max-width:73px}.filters-by-time button.btn.active[data-v-79facaf4]{background-color:#29abe2!important;color:#fff}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/FiltersByTime.vue"],"names":[],"mappings":"AACA,kCACE,cAAe,AACf,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,WAAuB,CACxB,AACD,6CACI,gCAAmC,AACnC,+CAAoD,AAC5C,uCAA4C,AACpD,cAAe,AACf,yBAA2B,AAC3B,YAAa,AACb,iBAAkB,AAClB,cAAgB,CACnB,AACD,oDACM,mCAAqC,AACrC,UAAa,CAClB","file":"FiltersByTime.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.filters-by-time[data-v-79facaf4] {\n  color: #85939e;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: calc(102px * 4);\n}\n.filters-by-time button.btn[data-v-79facaf4] {\n    background-color: white !important;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n    color: #85939e;\n    font-size: 14px !important;\n    height: 40px;\n    margin-left: 14px;\n    max-width: 73px;\n}\n.filters-by-time button.btn.active[data-v-79facaf4] {\n      background-color: #29abe2 !important;\n      color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("6dcc94fc", content, true);

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1098),
  /* template */
  __webpack_require__(1106),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79facaf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "filters-by-time"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'active': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.applyFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t" + _vm._s(filter.label) + "\n\t")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(59);



var printReport = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var baseUrl, dateStart, dateEnd, idSubsidiary, name, responseType, cardModel, response, blob;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api' + '/report/restaurant';
						dateStart = this.dateStart;
						dateEnd = this.dateEnd;
						idSubsidiary = this.idSubsidiary;
						name = 'Reporte Restaurante';
						responseType = 'blob';
						cardModel = { loadTable: [{}] };
						_context.next = 9;
						return this.$http.post(baseUrl + '?dateStart=' + dateStart + '&dateEnd=' + dateEnd + '&idSubsidiary=' + idSubsidiary, cardModel, { responseType: responseType });

					case 9:
						response = _context.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function printReport() {
		return _ref.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							dateStart: this.dateStart,
							dateEnd: this.dateEnd,
							idSubsidiary: this.idSubsidiary
						};
						_context2.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/booking-report/restaurat', { params: params });

					case 3:
						response = _context2.sent;

						this.rows = response.data.data;

					case 5:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadData() {
		return _ref2.apply(this, arguments);
	};
}();

var loadHotels = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _ref4, subsidiaries;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/hotel');

					case 2:
						_ref4 = _context3.sent;
						subsidiaries = _ref4.data;

						this.subsidiaries = subsidiaries.data;
						this.idSubsidiary = this.subsidiaries[0].id;

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadHotels() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var helperMethods = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].methods;

function customButtons() {
	this.printReport();
}

function onDateFilter(filter) {
	this.value = filter.id;
	if (this.value === 1) {
		this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 0), 'YYYY-MM-DD');
	} else {
		this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 7), 'YYYY-MM-DD');
	}
	this.loadData();
}

function data() {
	return {
		date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		subsidiary: 0,
		value: 1,
		totalPage: 1,
		currentPage: 1,
		lastPage: 0,
		filters: [{ id: 1, value: 'Hoy' }, { id: 2, value: 'Semana' }],
		columns: [{ id: 1, name: '# Rva', code: 'code', isSortable: { down: false, up: false } }, { id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } }, { id: 3, name: 'Canal de Rva', code: 'canal', isSortable: { down: false, up: false } }, { id: 4, name: 'País', code: 'country', isSortable: { down: false, up: false } }, { id: 5, name: 'Hab.', code: 'room', isSortable: { down: false, up: false } }, { id: 6, name: 'Estado', code: 'state', isSortable: { down: false, up: false } }, { id: 7, name: 'Fec. Entrada', code: 'checkIn', isSortable: { down: false, up: false } }, { id: 8, name: 'Fec. Salida', code: 'checkOut', isSortable: { down: false, up: false } }, { id: 9, name: '# Huespedes', code: 'huesped', isSortable: { down: false, up: false } }],
		rows: [],
		menuStart: false,
		menuEnd: false,
		dateEnd: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		dateStart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["subDays"])(new Date(), 0), 'YYYY-MM-DD'),
		subsidiaries: [],
		idSubsidiary: '',
		loading: false
	};
}

function arrowIconStart() {
	var arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconEnd() {
	var arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function created() {
	this.loadHotels();
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'restaurant',
	created: created,
	data: data,
	components: {
		FiltersByTime: __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_2_table_run___default.a
	},
	computed: {
		arrowIconStart: arrowIconStart,
		arrowIconEnd: arrowIconEnd
	},
	methods: {
		printReport: printReport,
		customButtons: customButtons,
		loadData: loadData,
		onDateFilter: onDateFilter,
		loadHotels: loadHotels
	}
});

/***/ }),

/***/ 1431:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, "th[data-v-8982b724]{background-color:#545e72}tr[data-v-8982b724]:nth-child(odd){background-color:hsla(0,0%,95%,.5)}tr[data-v-8982b724]:nth-child(2n){background-color:#fff}.header-booking-data[data-v-8982b724]{height:31px;position:absolute;right:20px;text-align:right;top:50px;width:calc(100% - 230px)}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/reports/Restaurant.vue"],"names":[],"mappings":"AACA,oBACE,wBAA0B,CAC3B,AACD,mCACE,kCAA2C,CAC5C,AACD,kCACE,qBAAwB,CACzB,AACD,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B","file":"Restaurant.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\nth[data-v-8982b724] {\n  background-color: #545e72;\n}\ntr[data-v-8982b724]:nth-child(odd) {\n  background-color: rgba(241, 241, 241, 0.5);\n}\ntr[data-v-8982b724]:nth-child(even) {\n  background-color: white;\n}\n.header-booking-data[data-v-8982b724] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 50px;\n  width: calc(100% - 230px);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1431);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("352f3e1a", content, true);

/***/ }),

/***/ 1682:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "xl-2": "",
      "lg2": "",
      "text-xs-right": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.idSubsidiary),
      callback: function($$v) {
        _vm.idSubsidiary = $$v
      },
      expression: "idSubsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "d-flex": "",
      "row": "",
      "wrap": "",
      "ml-2": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "mt-1": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "disabled": !_vm.dateStart,
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "mt-1": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('section', {
    staticClass: "filters-by-time"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'activeBtn': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.onDateFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(filter.value) + "\n\t\t\t\t")])
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.customButtons
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n\t\t\t\tImprimir Reporte\n\t\t\t\t")], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table no-search-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-search": false,
      "selectable": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.customer ? props.row.customer.data.name : '') + " " + _vm._s(props.row.customer ? props.row.customer.data.lastname : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.channel ? props.row.channel.data.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingRooms.data.roomTypes ? props.row.bookingRooms.data.codeRoomtype : '') + _vm._s(props.row.bookingRooms.data.roomTypes ? props.row.bookingRooms.data.roomTypes.data.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.paymentStatus.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingStart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.bookingEnd))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.totalPerson))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1516)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1306),
  /* template */
  __webpack_require__(1682),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8982b724",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/54.398b607954325224f084.js